import DeliveryModesPage from "../../pages/legacy/deliveryModes/DeliveryModesPage";

const route = {
  key: "deliveryModes",
  path: "/legacy/delivery-modes",
  component: DeliveryModesPage,
  private: true,
  layout: "main",
  icon: "faTruck",
  group: "configuration",
  order: 10,
  permission: "legacy.deliveryModes.read"
};

export default route;